module.exports = __webpack_public_path__ + "static/chromedevtools2-e1c7e88aea89c5c3a2ad82b4b1eb15db.png";